import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetDeclaracionJuradaCeseActividadParcialByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetDeclaracionJuradaCeseActividadParcialByUser = () => {
  const [loadingGetDeclaracionJuradaCeseActividadParcialByUser, setLoadingGetDeclaracionJuradaCeseActividadParcialByUser] = useState(false);
  const [successGetDeclaracionJuradaCeseActividadParcialByUser, setSuccessGetDeclaracionJuradaCeseActividadParcialByUser] = useState(false);
  const [errorGetDeclaracionJuradaCeseActividadParcialByUser, setErrorGetDeclaracionJuradaCeseActividadParcialByUser] = useState<any>(null);
  const [dataGetDeclaracionJuradaCeseActividadParcialByUser, setDataDeclaracionJuradaCeseActividadParcialByUser] = useState<any>(null);

  const [statusGetDeclaracionJuradaCeseActividadParcialByUser, setStatusGetDeclaracionJuradaCeseActividadParcialByUser] =
    useState<StatusGetDeclaracionJuradaCeseActividadParcialByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getDeclaracionJuradaCeseActividadParcialByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetDeclaracionJuradaCeseActividadParcialByUser(true);
    setSuccessGetDeclaracionJuradaCeseActividadParcialByUser(false);
    setErrorGetDeclaracionJuradaCeseActividadParcialByUser(null);

    try {
      const res = await apirecord.getSolicitudDeclaracionJuradaParcialByUser(userId, expedienteId);

      setStatusGetDeclaracionJuradaCeseActividadParcialByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetDeclaracionJuradaCeseActividadParcialByUser(true);
      setDataDeclaracionJuradaCeseActividadParcialByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetDeclaracionJuradaCeseActividadParcialByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetDeclaracionJuradaCeseActividadParcialByUser(err);
      console.error("Error en getDeclaracionJuradaCeseActividadParcialByUser:", err);

      throw err;

    } finally {
      setLoadingGetDeclaracionJuradaCeseActividadParcialByUser(false);
    }
  };

  return {
    getDeclaracionJuradaCeseActividadParcialByUser,
    loadingGetDeclaracionJuradaCeseActividadParcialByUser,
    successGetDeclaracionJuradaCeseActividadParcialByUser,
    errorGetDeclaracionJuradaCeseActividadParcialByUser,
    dataGetDeclaracionJuradaCeseActividadParcialByUser,
    statusGetDeclaracionJuradaCeseActividadParcialByUser
  };
};

export default useGetDeclaracionJuradaCeseActividadParcialByUser;
